import React from 'react';
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { FloatLabel } from "primereact/floatlabel";
import { Avatar } from "primereact/avatar";

export const getBranchOptions = () => [
  { name: "Administracyjna", value: "admin", code: "rgba(255, 0, 255, 0.5)" },
  { name: "Architektoniczna", value: "architectural", code: "rgba(105, 58, 58, 0.5)" },
  { name: "Drogowa", value: "road", code: "rgba(0, 255, 0, 0.5)" },
  { name: "Elektryczna", value: "electrical", code: "rgba(255, 0, 0, 0.5)" },
  { name: "Konstrukcyjna", value: "construction", code: "rgba(87, 87, 87, 0.5)" },
  { name: "Sanitarna", value: "sanitary", code: "rgba(0, 0, 255, 0.5)" }
];

export default function BranchDropdown({
  selectedBranch,
  onBranchSelect,
  width = "100%",
  className,
  floating = true,
  label = true,
  multiSelect = false
}) {
  const data = getBranchOptions();

  const itemTemplate = (option) => (
    <div className="flex items-center gap-2">
      <Avatar
        shape="square"
        size="small"
        style={{
          backgroundColor: option?.code ?? "transparent",
          width: "2rem",
          height: "1rem",
          border: "1px solid #ccc"
        }}
      />
      <span>{option?.name}</span>
    </div>
  );

  const valueTemplate = (option) => {
    const fullOption = data.find((x) => x.value === option) || option;
    return fullOption ? itemTemplate(fullOption) : null;
  };

  const handleMultiSelectChange = (selectedValues) => {
    onBranchSelect(selectedValues);
  };

  const multiSelectValue = () => {
    return selectedBranch || [];
  };

  const dropdown = multiSelect ? (
    <MultiSelect
      value={multiSelectValue()}
      onChange={(e) => handleMultiSelectChange(e.value)}
      options={data}
      optionLabel="name"
      optionValue="value"
      placeholder="Wybierz..."
      className={className}
      style={{ width }}
      inputId="group-in"
      itemTemplate={itemTemplate}
      display="chip"
      maxSelectedLabels={2}
      selectedItemsLabel="{0} wybrane"
      emptyFilterMessage="Nie znaleziono wyników"
      selectAll={false}
    />
  ) : (
    <Dropdown
      value={selectedBranch ?? []}
      onChange={(e) => onBranchSelect(e.value)}
      options={data}
      optionLabel="name"
      placeholder="Wybierz..."
      className={className}
      style={{ width }}
      inputId="group-in"
      itemTemplate={itemTemplate}
      valueTemplate={valueTemplate}
    />
  );

  return (
    <>
      {!floating ? (
        <>
          {label && <label htmlFor="group-in">Branża</label>}
          {dropdown}
        </>
      ) : (
        <FloatLabel className={className} style={{ width }}>
          {dropdown}
          <label htmlFor="group-in">Branża</label>
        </FloatLabel>
      )}
    </>
  );
}

export function BranchView({ value, short = false }) {
  const data = getBranchOptions();
  const option = data.find((x) => x.value === value);

  if (!option) return null;

  const displayName = short ? option.name.substring(0, 4) : option.name;

  return (
    <div className="flex items-center gap-2">
      <Avatar
        shape="square"
        size="small"
        style={{
          backgroundColor: option.code,
          width: "2rem",
          height: "1rem",
          border: "1px solid #ccc"
        }}
      >{option?.code ? null : "?"}</Avatar>
      <span>{displayName}</span>
    </div>
  );
}
